import { useEffect, useState } from "react";
import api from "@/lib/api";

const CARDS = [["found", "Encontrados"], ["demos", "Demonstrações"], ["sent", "Enviados"], ["demo_opens", "Demonstrações abertas"],
  ["replies", "Respostas"], ["meetings", "Reuniões"], ["clients", "Novos clientes"]];

function Conv({ title, rows }) {
  return (
    <div className="rounded-2xl border border-border p-4">
      <h3 className="mb-2 font-display font-bold">{title}</h3>
      {rows.map((r) => <div key={r.key} className="flex justify-between text-sm capitalize"><span>{r.key}</span><span>{r.clientes}/{r.total} · {r.rate}%</span></div>)}
      {!rows.length && <p className="text-sm text-muted-foreground">Sem dados.</p>}
    </div>
  );
}

export function ProspectStats() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/prospect/stats").then(({ data }) => setS(data)); }, []);
  if (!s) return null;
  return (
    <div className="space-y-4" data-testid="prospect-stats">
      <div className="grid grid-cols-2 gap-3 md:grid-cols-4 lg:grid-cols-7">
        {CARDS.map(([k, l]) => (
          <div key={k} className="rounded-2xl bg-secondary p-4"><div className="text-xs text-muted-foreground">{l}</div><div className="font-display text-2xl font-extrabold" data-testid={`stat-${k}`}>{s[k]}</div></div>
        ))}
      </div>
      <div className="grid gap-3 md:grid-cols-2"><Conv title="Conversão por país" rows={s.by_country} /><Conv title="Conversão por setor" rows={s.by_sector} /></div>
    </div>
  );
}
